import { Dialog, DialogContent, DialogHeading, Typography } from 'omakase';
import { consumer, core } from '@tock/coretypes';
import { patronAndFullAchievementsSelector } from 'selectors/achievementsSelectors';
import { useSelector } from 'react-redux';
import Achievement from './Achievement';

interface Props {
  onSetAchievementsModalIsOpen(isOpen: boolean): void;
  isOpen: boolean;
}

const AchievementsModal = ({ onSetAchievementsModalIsOpen, isOpen }: Props) => {
  const patronAndFullAchievementPairs = useSelector(patronAndFullAchievementsSelector);
  const onClose = () => {
    onSetAchievementsModalIsOpen(false);
  };
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="achievements-title"
      aria-describedby="achievements-description"
    >
      <DialogHeading id="achievements-title" onClose={onClose}>
        Your Achievements
      </DialogHeading>
      <DialogContent id="achievements-description">
        <ul>
          {patronAndFullAchievementPairs.map((patronAndFullAchievementPair) => (
            <AchievementDescription
              key={patronAndFullAchievementPair.fullAchievement.name}
              {...patronAndFullAchievementPair}
            />
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};

interface AchievementDescriptionProps {
  patronAchievement?: core.PatronProfileAchievement;
  fullAchievement: consumer.AchievementDescription;
}

const AchievementDescription = ({
  patronAchievement,
  fullAchievement,
}: AchievementDescriptionProps) => {
  const name = (patronAchievement && patronAchievement.name) || fullAchievement.name;
  const isAchieved = !!patronAchievement;
  let nextLevelDescription: string | undefined;
  const nextLevelIndex = (patronAchievement && patronAchievement.level + 1) || 1;

  if (!isAchieved) {
    nextLevelDescription = fullAchievement.level[0].description || undefined;
  } else if (nextLevelIndex < fullAchievement.level.length) {
    nextLevelDescription = `Unlock next level: ${fullAchievement.level[nextLevelIndex].description}`;
  } else {
    // already at max level
    nextLevelDescription = undefined;
  }

  const detailsText = [patronAchievement && patronAchievement.description, nextLevelDescription]
    .filter((desc) => !!desc)
    .join(' - ');
  return (
    <li className="Achievement-row">
      <Achievement
        name={patronAchievement ? patronAchievement.name : fullAchievement.name}
        level={patronAchievement && patronAchievement.level}
        isAchieved={isAchieved}
        variant="large"
      />
      <div className="Achievement-row-description">
        <div>
          <Typography component="h2" variant="body02Strong">
            {name}
          </Typography>
          <div className="Achievement-row-details">
            <Typography component="span" variant="body02" color="fgSubtle">
              {detailsText}
            </Typography>
          </div>
        </div>
      </div>
    </li>
  );
};

export default AchievementsModal;
